import "./front.scss";

const BASE_CLASSNAME = "srsr-block-feedback";
const MODAL_BASE_CLASSNAME = "srsr-block-feedback-modal";
const MODAL_OPEN_CLASSNAME = "opened";
const SCROLL_DISABLE_CLASSNAME = "modal-opened";
const LOADING_CLASSNAME = "is-loading";
const HAS_ERROR_CLASSNAME = "has-error";
const EMAIL_VALIDATE_PATTERN = /^[a-zA-Z0-9\._-]+@[a-zA-Z0-9\._-]+\.\w{2,}$/;

const closeModal = ( modal ) => {
    const isHelpfulField = modal.querySelector(`.${MODAL_BASE_CLASSNAME}__form-field__feedback-is-helpful`);
    modal.classList.remove(MODAL_OPEN_CLASSNAME);
    document.body.classList.remove(SCROLL_DISABLE_CLASSNAME);
    isHelpfulField.value = '';

    const helpfulFieldSelected = modal.querySelectorAll(`[class*="${BASE_CLASSNAME}__button__"]`);
    if ( helpfulFieldSelected ){
        helpfulFieldSelected.forEach(item => item.classList.remove('selected'));
    }
}

const updateFieldValidity = (field, valid) => {
    const wrapper = field.closest(`.${MODAL_BASE_CLASSNAME}__field`);
    if (valid) {
        wrapper.classList.remove('invalid');
    } else {
        wrapper.classList.add('invalid');
    }

    return valid;
}

const validateEmail = ( field ) => updateFieldValidity(field, EMAIL_VALIDATE_PATTERN.test( field.value ));
const validateName = ( field ) => updateFieldValidity(field, !!field.value.trim());

HTMLFormElement.prototype.serializeFormJSON = function () {
    return Object.fromEntries( new FormData( this ) );
};

window.srsrGReCaptchaWidgetId = null;

const recaptchaErrorCallback = wrapElement => {
    wrapElement.classList.add( HAS_ERROR_CLASSNAME );
};

const recaptchaSuccessCallback = wrapElement => {
    wrapElement.classList.remove( HAS_ERROR_CLASSNAME );
};

window.reCaptchaOnLoadCallback = () => {
    const grecaptchaFieldWrap = document.querySelector(`.${MODAL_BASE_CLASSNAME}__form-recaptcha`);
    if( window.srsrGReCaptchaWidgetId === null ) {
        if( grecaptchaFieldWrap.dataset.siteKey ) {
            window.srsrGReCaptchaWidgetId = window.grecaptcha.render(grecaptchaFieldWrap, {
                'sitekey': grecaptchaFieldWrap.dataset.siteKey,
                'expired-callback': function () {
                    window.grecaptcha.reset(window.srsrGReCaptchaWidgetId);
                },
                'callback': function (response) {
                    if (!response) {
                        recaptchaErrorCallback(grecaptchaFieldWrap);
                    } else {
                        recaptchaSuccessCallback(grecaptchaFieldWrap);
                    }
                },
            });
        }
    }
}

addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
        const feedbackButton = e.target.closest(`.${BASE_CLASSNAME}__button`);
        if (!feedbackButton) {
            return;
        }

        let userFeedback = feedbackButton.dataset.feedback ?? "";
        if (! userFeedback) {
            return;
        }

        const wrapper = document.querySelector(`.${BASE_CLASSNAME}`);
        const modal = document.querySelector(`.${MODAL_BASE_CLASSNAME}__wrap`);
        const isHelpfulField = modal.querySelector(`.${MODAL_BASE_CLASSNAME}__form-field__feedback-is-helpful`);
        const helpfulFieldText = wrapper.querySelector(`.${BASE_CLASSNAME}__title`);

        let helpfulFieldLabel = ''
        if( helpfulFieldText ){
            helpfulFieldLabel = helpfulFieldText.textContent;
        }

        modal.querySelector(`.${MODAL_BASE_CLASSNAME}__form-field__value`).textContent = helpfulFieldLabel;

        modal.classList.add(MODAL_OPEN_CLASSNAME);
        document.body.classList.add(SCROLL_DISABLE_CLASSNAME);
        isHelpfulField.value = userFeedback;

        const helpfulFieldSelected = modal.querySelector(`.${BASE_CLASSNAME}__button__${userFeedback}`);
        if ( helpfulFieldSelected ){
            helpfulFieldSelected.classList.add('selected');
        }

        const grecaptchaFieldWrap = document.querySelector(`.${MODAL_BASE_CLASSNAME}__form-recaptcha`);

        if( grecaptchaFieldWrap && grecaptchaFieldWrap.dataset.siteKey && window.srsrGReCaptchaWidgetId === null ) {
            const script = document.createElement('script');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=reCaptchaOnLoadCallback&render=explicit');
            document.head.appendChild(script);
        }
    });

    document.addEventListener("click", (e) => {
        const modalCloseButton = e.target.closest(`.${MODAL_BASE_CLASSNAME}__close`);
        if (!modalCloseButton) {
            return;
        }

        const modal = e.target.closest(`.${MODAL_BASE_CLASSNAME}__wrap`);
        modal && closeModal(modal);
    });

    document.addEventListener("click", (e) => {
        const overlay = e.target.closest(`.${MODAL_BASE_CLASSNAME}__overlay`);
        if (!overlay) {
            return;
        }

        const modal = e.target.closest(`.${MODAL_BASE_CLASSNAME}__wrap`);
        modal && closeModal(modal);
    });

    document.getElementById("srsr-block-feedback-modal__form-field__name")?.addEventListener("blur", (e) => validateName( e.target ));
    document.getElementById("srsr-block-feedback-modal__form-field__email")?.addEventListener("blur", (e) => validateEmail( e.target ));

    document.addEventListener("submit", (e) => {
        const modalForm = e.target.closest(`.${MODAL_BASE_CLASSNAME} form`);
        if (! modalForm) {
            return;
        }

        let restUrl = modalForm.getAttribute('action') || "";
        if (!restUrl) {
            return;
        }

        e.preventDefault();

        const modal = e.target.closest(`.${MODAL_BASE_CLASSNAME}__wrap`);
        const loader = modal.querySelector(`.${MODAL_BASE_CLASSNAME}__loader`);
        const nameField = modalForm.querySelector(`#${MODAL_BASE_CLASSNAME}__form-field__name`);
        const emailField = modalForm.querySelector(`#${MODAL_BASE_CLASSNAME}__form-field__email`);
        if (
          (nameField && !validateName(nameField)) || (emailField && !validateEmail(emailField))
        ) {
            return;
        }

        if( window.srsrGReCaptchaWidgetId !== null ){
            const response = window.grecaptcha.getResponse( window.srsrGReCaptchaWidgetId );
            const grecaptchaFieldWrap = document.querySelector(`.${MODAL_BASE_CLASSNAME}__form-recaptcha`);

            if( response.length === 0 ) {
                recaptchaErrorCallback( grecaptchaFieldWrap );
            }else{
                recaptchaSuccessCallback( grecaptchaFieldWrap );
            }
        }

        if ( loader.classList.contains( LOADING_CLASSNAME ) ) {
            return;
        }

        loader.classList.add(LOADING_CLASSNAME);
        const data = modalForm.serializeFormJSON();

        fetch(restUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': feedbackFormNonce
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(data)
        })
        .then((res) => res.json())
        .then(({status, message}) => {
            if ( status === true ) {
                modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message-wrap`).classList.add('visible');
                modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message`).textContent = message;

                setTimeout(() => {
                    closeModal(modal);
                    modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message-wrap`).classList.remove('visible');

                    modalForm.reset();
                }, 2000);
            } else {
                modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message`).textContent = message;
                modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message-wrap`).classList.add('visible');
                //     emailField.closest(`.${MODAL_BASE_CLASSNAME}__field`).classList.add('invalid');
                setTimeout(() => {
                    modal.querySelector(`.${MODAL_BASE_CLASSNAME}__message-wrap`).classList.remove('visible');
                }, 2000 );
            }
        })
        .catch(() => console.log("Something went wrong. Please try again."))
        .finally(() => {
            loader.classList.remove(LOADING_CLASSNAME);
            if( window.srsrGReCaptchaWidgetId !== null ) {
                window.grecaptcha.reset(window.srsrGReCaptchaWidgetId);
            }
        });
    });
});